export interface TemplateContent {
  id: string;
  title: string;
  desc: string;
  format: "PDF" | "Word";
  locked: boolean;
  type?: 'inspection' | 'corrective' | 'rain' | 'admin' | 'log';
  sections: {
    header: string;
    fields: string[];
  }[];
}

export const templates: TemplateContent[] = [
  {
    id: "weekly-log",
    title: "Weekly Inspection Log",
    desc: "Record site conditions and BMP observations during routine inspections.",
    format: "PDF",
    locked: false,
    type: 'inspection',
    sections: [
      {
        header: "Site Conditions",
        fields: ["Phase of Construction", "Current Soil Disturbance", "Stabilized Areas"]
      },
      {
        header: "BMP Status",
        fields: ["Perimeter Controls", "Inlet Protection", "Exit Stabilization", "Waste Management"]
      }
    ]
  },
  {
    id: "corrective-action",
    title: "Corrective Action Log",
    desc: "Organize BMP repairs, responsible personnel, and completion dates.",
    format: "PDF",
    locked: false,
    type: 'corrective',
    sections: [
      {
        header: "Problem Identification",
        fields: ["Date Noted", "BMP Location", "Description of Failure"]
      },
      {
        header: "Resolution",
        fields: ["Action Taken", "Date Completed", "Personnel Responsible"]
      }
    ]
  },
  {
    id: "rain-event-form",
    title: "Post-Storm Assessment",
    desc: "Record rainfall, discharge observations, and site conditions after a storm.",
    format: "PDF",
    locked: false,
    type: 'rain',
    sections: [
      {
        header: "Weather Data",
        fields: ["Rainfall Amount (Inches)", "Storm Duration", "Time Since Last Rain"]
      },
      {
        header: "Discharge Assessment",
        fields: ["Evidence of Discharge?", "Water Clarity", "Downstream Impacts"]
      }
    ]
  },
  {
    id: "delegation-authority",
    title: "Delegation of Authority",
    desc: "Draft a record of delegated responsibilities for review against your permit requirements.",
    format: "PDF",
    locked: false,
    type: 'admin',
    sections: [
      {
        header: "Designated Person",
        fields: ["Name of Designee", "Title", "Company", "Responsibilities"]
      },
      {
        header: "Authorization",
        fields: ["I authorize the person above to sign reports...", "Operator Signature", "Date"]
      }
    ]
  },
  {
    id: "grading-stabilization",
    title: "Grading & Stabilization Log",
    desc: "Track activity dates, stabilization methods, and areas needing follow-up.",
    format: "PDF",
    locked: false,
    type: 'log',
    sections: [
      {
        header: "Area Identification",
        fields: ["Location on Site", "Last Day of Activity", "Planned Resume Date"]
      },
      {
        header: "Stabilization Method",
        fields: ["Temporary (Straw/Hydro)", "Permanent (Sod/Pave)", "Date Applied"]
      }
    ]
  }
];
